import apiClient from '@src/api/clients';

const CLIENT_BASE_URL = 'client-inbox/client-knowledge-documents/';
const COMPANY_BASE_URL = 'client-inbox/company-knowledge-documents/';

const cleanParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== undefined && value !== null && value !== ''
    ),
  );

export const listClientDocuments = (params = {}) =>
  apiClient.request({
    url: CLIENT_BASE_URL,
    method: 'GET',
    payload: cleanParams(params),
  });

export const createClientDocument = (payload) =>
  apiClient.request({ url: CLIENT_BASE_URL, method: 'POST', payload });

export const updateClientDocument = (id, payload) =>
  apiClient.request({ url: `${CLIENT_BASE_URL}${id}/`, method: 'PATCH', payload });

export const deleteClientDocument = (id) =>
  apiClient.request({ url: `${CLIENT_BASE_URL}${id}/`, method: 'DELETE' });

export const listCompanyDocuments = (params = {}) =>
  apiClient.request({
    url: COMPANY_BASE_URL,
    method: 'GET',
    payload: cleanParams(params),
  });

export const createCompanyDocument = (payload) =>
  apiClient.request({ url: COMPANY_BASE_URL, method: 'POST', payload });

export const updateCompanyDocument = (id, payload) =>
  apiClient.request({ url: `${COMPANY_BASE_URL}${id}/`, method: 'PATCH', payload });

export const deleteCompanyDocument = (id) =>
  apiClient.request({ url: `${COMPANY_BASE_URL}${id}/`, method: 'DELETE' });

export default {
  listClientDocuments,
  createClientDocument,
  updateClientDocument,
  deleteClientDocument,
  listCompanyDocuments,
  createCompanyDocument,
  updateCompanyDocument,
  deleteCompanyDocument,
};
